import { render, staticRenderFns } from "./ChannelTable.vue?vue&type=template&id=1806c20c"
import script from "./ChannelTable.vue?vue&type=script&lang=js"
export * from "./ChannelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports